import { IAssemblyApplicationResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const assemblyApplicationDefaultSort: DataSourceSort[] = [
    { field: 'Name', dir: 'asc' },
];

export type AssemblyApplicationsFilter = Readonly<{
    nameSearch?: string;
    assemblyTypeId?: number;
}>;

export type UseAssemblyApplicationDataSourceOptions = BaseDataSourceOptions<
    IAssemblyApplicationResponse,
    AssemblyApplicationsFilter
>;

const getAssemblyApplications: DataSourceQuery<
    IAssemblyApplicationResponse,
    AssemblyApplicationsFilter
> = async ({ filter: { nameSearch, assemblyTypeId }, sort, page, pageLimit }) => {
    const filter = Filter.and(
        nameSearch ? Filter.contains('Name', nameSearch) : undefined,
        assemblyTypeId ? Filter.eq('Type.Id', assemblyTypeId) : undefined,
    );
    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getAssemblyApplications({ filter, page, pageLimit, orderBy }),
    );
};

export type AssemblyApplicationPagedDataSource = PagedDataSource<
    IAssemblyApplicationResponse,
    AssemblyApplicationsFilter
>;

export function usePagedAssemblyApplicationDataSource({
    defaultSort = assemblyApplicationDefaultSort,
    ...options
}: UseAssemblyApplicationDataSourceOptions): AssemblyApplicationPagedDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAssemblyApplications,
    });
}

export type AssemblyApplicationInfiniteDataSource = InfiniteDataSource<
    IAssemblyApplicationResponse,
    AssemblyApplicationsFilter
>;

export function useInfiniteAssemblyApplicationsDataSource({
    defaultSort = assemblyApplicationDefaultSort,
    ...options
}: UseAssemblyApplicationDataSourceOptions): AssemblyApplicationInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getAssemblyApplications,
    });
}
